var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgNotification(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    className: "notification_svg__st1",
    d: "M27.1 25.4v-8c0-3.6-2.6-6.5-6-7.1V9c0-.7-.6-1.2-1.2-1.2s-1.3.6-1.3 1.2v1.2c-3.4.6-6 3.5-6 7.1v8l-2.5.9v1.5h19.4v-1.5l-2.4-.8z",
    stroke: "#e1087e",
    strokeWidth: 2.5
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    className: "notification_svg__st1",
    d: "M17.2 29.1c0 1.5 1.2 2.7 2.7 2.7s2.7-1.2 2.7-2.7v-.2h-5.4v.2z",
    fill: "currentColor",
    stroke: "#e1087e",
    strokeWidth: 2.5
  })));
}
export default SvgNotification;